"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const borderStyle = {
    borderRadius: "5px",
    border: "1px solid #ccd6db",
    padding: "15px",
};
exports.BorderContainer = (props) => {
    const { content } = props;
    return (React.createElement("div", { style: borderStyle }, content));
};
//# sourceMappingURL=BorderContainer.js.map